import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './BitsComponents/Footer';
import ContactForm from './BitsComponents/ContactForm';
import Community from './BitsComponents/Community';
import HeroSection from './BitsComponents/Homepage';
import ExpertiseSection from './BitsComponents/Services';
import Carouselpage from './BitsComponents/Carouselpage';
import VisionValueSection from './AboutComponent/VisionValueSection';
import AboutSection from './AboutComponent/AboutSection';
import AboutMain from './AboutComponent/AboutMain';
import ContactSection from './ContactComponent/ContactSection';
import ContactMain from './ContactComponent/ContactMain';
import Contactnav from './ContactComponent/Contactnav';
import Aboutnav from './AboutComponent/Aboutnav';
import CareersMain from './CareersComponent/CareersMain';
import Careersnav from './CareersComponent/Careersnav';

import CareersMiddle from './CareersComponent/Careersimagemiddle';
import Servicenav from './ServicesComponent/Servicesnav';
import ServiceMain from './ServicesComponent/ServicesMain';
import ServiceAbout from './ServicesComponent/ServiceAbout';
import ServicesOffered from './ServicesComponent/ServicesOffered';
import ITServiceSection from './ServicesComponent/ServicesImageSection';
import Featurechoose from './BitsComponents/Featurechoose';
import AboutCEO from './AboutComponent/AboutCEO';
import AIBot from './BitsComponents/AIBot';
import BillingMain from './BillingSolutions/BillingMain';
import Billingnav from './BillingSolutions/Billingnav';
import Billingchoose from './BillingSolutions/Billingchoose';
import ResourceSection from './BillingSolutions/ResourceSection';
import Carouselnew from './BitsComponents/CarouselNew';
import Expertise from './BitsComponents/Expertise';
import AboutJoinusimage from './AboutComponent/AboutJoinusimage';
import Explorecareers from './CareersComponent/Explorecareers';
import ApplicationProcess from './CareersComponent/ApplicationProcess';
import JobApplicationForm from './CareersComponent/JobApplicationForm';
import ScrollToTop from './BitsComponents/ScrollToTop';
import Projectsnav from './ProjectsComponent/Projectsnav';
import ProjectsMain from './ProjectsComponent/ProjectsMain';
import ProjectsGrid from './ProjectsComponent/ProjectsGrid';
function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={
                    <>
                        <AIBot />
                        <Carouselpage />
                        <Carouselnew />
                     
                        <ExpertiseSection />
                        <HeroSection />
                         
                        {/* <Features/> */}
                        {/* <BlogGenerator /> */}
                         
                        <Featurechoose />
                        <Expertise />
                        <Community />
                        <ContactForm />
                        <Footer />
                    </>
                } />

                {/*About Us page ka Route */}
                 
                <Route path="/about-us" element={
                    <>
                    <Aboutnav/>
                    <AboutMain/>
                    <AboutSection/>
                    <AboutCEO />
                    <AboutJoinusimage />
                    <VisionValueSection />
                    <Footer/>
                        </>
                    } />
                    {/*contact page ka Route*/}
 <Route path="/contact-bits" element={
    <>
    <Contactnav/>
    <ContactMain/>
    <ContactSection />
    <Footer/>
    </>
    } />
                    {/*careers page ka Route*/ }
    <Route path="/career-bits" element={
       <>
       <Careersnav/>
        <CareersMain />
        <Explorecareers />
        <ApplicationProcess />
        {/* <CareersJob /> */}
         
        {/* <HiringSection /> */}
        <CareersMiddle />
        <JobApplicationForm />
        <Footer />
        </>
        } />

                    {/*Service page ka Route*/}
<Route path="/service-bits" element={
    <>
    <Servicenav />
    <ServiceMain />
    <ServiceAbout />
    <ServicesOffered />
    <ITServiceSection />
    <Footer />
    </>
    }/>

    <Route path="/projects" element={
        <>
        <Projectsnav />
        <ProjectsMain />
        <ProjectsGrid />
        <Footer />
        </>
    } />

    <Route path="/billing" element={
        <>
        <Billingnav />
        <BillingMain />
        <Billingchoose />
        <ResourceSection />
        <Footer />
        </>
    } />
            </Routes>
        </Router>
    );
}

export default App;
